export const URLS = {
    LOGIN: "/login",
    INDEX: "/",
    HOME: "/home",
    TOKEN: "/api/account/token/",
    CATEGORY: "/registrations/category",
    PROJECTS: "/registrations/projects",
    FT_BOM_GROUPS: "/registrations/ft_bom_groups",
    PO_MONITORING: "/purchase_order/purchase_order",
    PO_MONITORING_DETAIL: "/purchase_order/purchase_order/:id",
    IMPORT_PO: "/imports/purchase_order",
    IMPORT_AMORTIZATION: "/imports/amortization",
    IMPORT_RELATED_COST: "/imports/related-cost",
    IMPORT_INTEGRATION_ROUTINES: "/imports/integration_routines",
    IMPORT_CONFIRMATION_MONITORING_PO: "/imports/confirmation_monitoring_po",

    REPORT_ASSET_CONTROL: "/reports/asset-control",
    REPORT_ASSET_CONTROL_INVOICE: "/reports/asset-control/:id",
    REPORT_RELATED_COST: "/reports/related-cost",
    REPORT_COST_ALLOCATION_PROJECT_CATEGORY: "/reports/cost-allocation-project-category",
    REPORT_STOCK_AND_MATERIAL_OUTPUT: "/reports/stock-and-material-output",
    REPORT_FTB_GENERAL: "/reports/ftb-general",
    DASHBOARD: "/dashboard",
    FTB_MOUNT_JIGA_RMA: "/reports/ftb-general/mount-jiga-rma/client/:idClient/ft-bom/:ftbom",
    REPLENISHMENT: "/replenishment",
    CLIENT: "/registrations/client",
    USER: "/registrations/users",
    PENDING_INVOICES: "/reports/pending-invoices",
    DENIED_ACCESS: "/denied-access",
    NPI_HOME: "/npi",
    MAPLOG_HOME: "/maplog",
    NPI_DASHBOARD: "/npi/dashboard",
    NPI_TEMPLATE: "/npi/configuration/template",
    NPI_TEMPLATE_DETAIL: "/npi/configuration/template/:id",
    NPI_CALENDAR: "/npi/configuration/calendar",
    NPI_PROJECT_PLANNING: "/npi/dashboard/project/:id",
    ACCESS_DENIED: "/access-denied",
}
